import { programGetDataApi, programTemplateGetDataApi, programChartDataGetApi } from "../../Api/Project/DefaultServices/Program/ProgramApi";
import {
    fetchProgrammeFailure,
    fetchProgrammeStart,
    fetchProgrammeSuccess,
    fetchProgramTemplateStart,
    fetchProgramTemplateFailure,
    fetchProgramTemplateSuccess,
    fetchProgramChartStart,
    fetchProgramChartFailure,
    fetchProgramChartSuccess
} from "../Slices/ProgrammeSlice";
import { AppDispatch } from "../Store";


export const fetchAllProgramme = (seriviceId: number) => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchProgrammeStart())
        const data = await programGetDataApi(seriviceId);
        if (data.status) {
            dispatch(fetchProgrammeSuccess(data.data || null));
        } else {
            dispatch(fetchProgrammeFailure(data.massage || ''));
        }

    } catch (e) {
        dispatch(fetchProgrammeFailure(e!.toString()));
    }
}

export const fetchAllProgramTemplate = () => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchProgramTemplateStart())
        const data = await programTemplateGetDataApi();
        if (data.status) {
            dispatch(fetchProgramTemplateSuccess(data.data || []));
        } else {
            dispatch(fetchProgramTemplateFailure(data.massage || ''));
        }

    } catch (e) {
        dispatch(fetchProgramTemplateFailure(e!.toString()));
    }
}

export const fetchProgrammeChart = (seriviceId: number) => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchProgramChartStart())
        const data = await programChartDataGetApi(seriviceId);
        if (data.status) {
            dispatch(fetchProgramChartSuccess(data.data || null));
        } else {
            dispatch(fetchProgramChartFailure(data.massage || ''));
        }

    } catch (e) {
        dispatch(fetchProgramChartFailure(e!.toString()));
    }
}